/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  KillswitchEditRequest,
  KillswitchEditRequest$Outbound,
  KillswitchEditRequest$outboundSchema,
} from "../components/killswitcheditrequest.js";

export type KillswitchesEditSecurity = {
  sessionHeaderGramSession: string;
};

export type KillswitchesEditRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  killswitchEditRequest: KillswitchEditRequest;
};

/** @internal */
export type KillswitchesEditSecurity$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const KillswitchesEditSecurity$outboundSchema: z.ZodMiniType<
  KillswitchesEditSecurity$Outbound,
  KillswitchesEditSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function killswitchesEditSecurityToJSON(
  killswitchesEditSecurity: KillswitchesEditSecurity,
): string {
  return JSON.stringify(
    KillswitchesEditSecurity$outboundSchema.parse(killswitchesEditSecurity),
  );
}

/** @internal */
export type KillswitchesEditRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  KillswitchEditRequest: KillswitchEditRequest$Outbound;
};

/** @internal */
export const KillswitchesEditRequest$outboundSchema: z.ZodMiniType<
  KillswitchesEditRequest$Outbound,
  KillswitchesEditRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    killswitchEditRequest: KillswitchEditRequest$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      killswitchEditRequest: "KillswitchEditRequest",
    });
  }),
);

export function killswitchesEditRequestToJSON(
  killswitchesEditRequest: KillswitchesEditRequest,
): string {
  return JSON.stringify(
    KillswitchesEditRequest$outboundSchema.parse(killswitchesEditRequest),
  );
}
